import React from 'react';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import styles from '@/common/containers/ModuleOverview/styles.less';
import { Trans, useTranslation } from 'react-i18next';
import CopyrightSup from '@/common/components/CopyrightSup';

const Main = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.blockBody}>
      <h4 className={styles.contentTitle}>
        {t('Main tasks module overview')}
      </h4>
      <div className={styles.contentDescription}>
        {t('Main task will assist with:')}
        <ul>
          <ol>
            {t(
              '1. Notifying significant parties and/or agencies of the death of the decedent.'
            )}
          </ol>
          <ol>
            {t(
              '2. Applying for death benefits the estate and/or survivors are entitled to (from governments, employers, insurance, etc).'
            )}
          </ol>
          <ol>
            {t(
              '3. Managing (i.e. modifying, transferring, ceasing, etc) services the decedent was using prior to their death.'
            )}
          </ol>
        </ul>
      </div>
      <h3 className={styles.contentSubTitle}>{t('Instructions')}</h3>
      <div className={styles.contentStepper}>
        <Stepper orientation="vertical">
          <Step active>
            <StepLabel className={styles.contentStep}>
              {t(
                'Complete the “Main tasks Questionnaire”. (This will identify main tasks and generate a “Main tasks List)'
              )}
            </StepLabel>
          </Step>
          <Step active>
            <StepLabel className={styles.contentStep}>
              {t('Start completing main tasks in the “Main tasks List”.')}
            </StepLabel>
          </Step>
        </Stepper>
      </div>
      <h3 className={styles.contentSubTitle}>{t('Timeframe')}</h3>
      <div className={styles.contentTimeFrame}>
        <ul>
          <ol>
            <Trans
              i18nKey="<1>Main tasks</1> should be started as soon as possible after confirming (through the <2>Legal tasks</2>) that the Executor has the legal authority to complete the various personal affairs tasks."
              components={{ 1: <b />, 2: <b /> }}
            />
          </ol>
        </ul>
      </div>
      <div className={styles.contentNoteWrap}>
        <div className="note">
          <Trans
            i18nKey="You can proceed with <1>Assets tasks</1> concurrent with <2>Main tasks</2> to expedite the PAEM<3></3> process."
            components={{ 1: <b />, 2: <b />, 3: <CopyrightSup /> }}
          />
        </div>
      </div>
    </div>
  );
};

export default Main;
